import React, { useContext } from 'react';
import { Tabs } from 'antd';
import { CrownOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import CompanyContext from '../../contexts/company/CompanyContext';
import { useCompanyTabs } from './useCompanyTabs';
import { COMPANY_PAGE_TITLE } from './CompanyPage';
import './CompanyPageHeader.css';

// Shared head of the "Mon entreprise" pages: each tab is its own route, rendered through PageScaffold's header
const CompanyPageHeader: React.FC = () => {
  const { activeCompany } = useContext(CompanyContext);
  const location = useLocation();
  const navigate = useNavigate();
  const tabs = useCompanyTabs();

  // a detail sub-route (e.g. /company/ai-receptionist/:subscriptionId) keeps its tab active
  const activeKey = tabs.find(
    (tab) => location.pathname === tab.path || location.pathname.startsWith(`${tab.path}/`)
  )?.path;

  return (
    <div className="company-page-header">
      <div className="company-page-header__top">
        <div>
          <span className="company-page-header__company">{activeCompany?.name}</span>
          <h1 className="company-page-header__title">{COMPANY_PAGE_TITLE}</h1>
        </div>
        {activeCompany?.isSupervisor && (
          <span className="company-page-header__role">
            <CrownOutlined /> Superviseur
          </span>
        )}
      </div>
      <Tabs
        className="company-page-header__tabs"
        activeKey={activeKey}
        onChange={(path) => navigate(path)}
        items={tabs.map((tab) => ({ key: tab.path, label: tab.title }))}
      />
    </div>
  );
};

export default CompanyPageHeader;
